import React, { useState } from "react";
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
import Zoom from '@material-ui/core/Zoom';

function CreateNote(props) {

    const [expanded , setExpanded] = useState(false);
    const [note, setNote] = useState(
        {
        title: "",
        content: ""
        }
    );

    function whenChanged(event) {

        const {name , value} = event.target;
     
        setNote(previousNote => {
            return {
                ...previousNote,
                [name] : value
            }
        });
     }

     function noteAdded(event) {
        if(note.title !== "" && note.content !== ""){
            props.whenAdd(note);
        }
        setNote({
            title: "",
            content: ""
        });
        event.preventDefault();
      
     }

     function expandArea() {
         setExpanded(true);

     }

    return (
    <div>
        <form className="create-note">

           {expanded && (<input
            name="title" 
            onChange={whenChanged}
            placeholder="Title" 
            value={note.title}>
            </input>)}

            
            <textarea 
            name="content" 
            onClick={expandArea}
            rows= {expanded ? 5 : 1 }
            onChange={whenChanged}
            value={note.content} 
            placeholder="Take a Note...." 
            
            />

            <Zoom in={expanded}>
             <Fab onClick={noteAdded}>
                 <AddIcon />
              </Fab>
            </Zoom>
            
        </form>
    </div>
    );
}

export default CreateNote;